import { Outlet } from 'react-router-dom';

/**
 * Khung của nhóm route `(auth)`: thẻ căn giữa, không có thanh điều hướng (§3.3).
 *
 * Nền dùng chuyển sắc utility — đây là một trong ba chỗ duy nhất được phép dùng
 * chuyển sắc (§5.16).
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 via-white to-dark-50 p-4">
      <Outlet />
    </div>
  );
}
